import React from "react";
import { LegalDocumentPage } from "@/components/legal/LegalDocumentPage";
import { PRIVACY_POLICY_MARKDOWN } from "@/lib/privacyPolicy";

export default function PrivacyPolicyPage() {
  return <LegalDocumentPage markdown={PRIVACY_POLICY_MARKDOWN} testId="privacy-page" />;
}
